export default __webpack_public_path__ + "65bbc0294760129332eb3338e41afb6c.png";